import React from 'react';
import {
  LineageBrowserDataCatalogProvider,
  VizPortalDataCatalogProviderProps,
} from '../../../data-catalog-shared';
import { WorkbookLineageSubplaceRouter, WorkbookLineageSubplaceRouterProps } from './WorkbookLineageSubplace';

export type EmbeddableWorkbookSubplaceProps = VizPortalDataCatalogProviderProps & WorkbookLineageSubplaceRouterProps;

export function EmbeddableWorkbookSubplaceWithoutRouter(props: EmbeddableWorkbookSubplaceProps): JSX.Element {
  return (
    <LineageBrowserDataCatalogProvider {...props}>
      <WorkbookLineageSubplaceRouter vizportalUrlId={props.vizportalUrlId} />
    </LineageBrowserDataCatalogProvider>
  );
}
